<mat-button-toggle-group class="without-checked-state">
  <mat-button-toggle
    class="zoom-in"
    (click)="tool.zoom('in', 'zoom_in_button')"
    matTooltip="Zoom In (SCROLL)"
  >
    <fa-icon [icon]="faSearchPlus" [fixedWidth]="true"></fa-icon>
  </mat-button-toggle>
  <mat-button-toggle
    class="zoom-out"
    (click)="tool.zoom('out', 'zoom_out_button')"
    matTooltip="Zoom Out (SCROLL)"
  >
    <fa-icon [icon]="faSearchMinus" [fixedWidth]="true"></fa-icon>
  </mat-button-toggle>
  <mat-button-toggle
    class="reset-zoom"
    (click)="tool.resetZoom({ source: 'reset_zoom_button' })"
    [matTooltip]="resetZoomTooltip"
  >
    <fa-icon [icon]="faExpandArrowsAlt" [fixedWidth]="true"></fa-icon>
  </mat-button-toggle>
  <mat-button-toggle
    *ngIf="showZoomPanelButton"
    class="zoom-panel-tool"
    (click)="tool.openZoomPanel()"
    [matTooltip]="'Open zoom panel'"
  >
    <!-- Wrapping this in a mat-icon causes it to have the wrong size -->
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 1.5H6.5C5.94688 1.5 5.5 1.94781 5.5 2.5V3H4V2.5C4 1.11937 5.11875 0 6.5 0H13.5C14.8813 0 16 1.11937 16 2.5V9.5C16 10.8813 14.8813 12 13.5 12H13V10.5H13.5C14.0531 10.5 14.5 10.0531 14.5 9.5V2.5C14.5 1.94781 14.0531 1.5 13.5 1.5ZM10 4C11.1031 4 12 4.89687 12 6V14C12 15.1031 11.1031 16 10 16H2C0.895313 16 0 15.1031 0 14V6C0 4.89687 0.895313 4 2 4H10ZM2 14.5H10C10.275 14.5 10.5 14.275 10.5 14V8H1.5V14C1.5 14.275 1.72375 14.5 2 14.5Z"
        fill="#333333"
      />
    </svg>
  </mat-button-toggle>
</mat-button-toggle-group>
